import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import cn from 'classnames';

import css from './zpMenuDropdown.module.css';

const Trigger = ({ children, className, ...props }: DropdownMenu.DropdownMenuTriggerProps) => (
  <DropdownMenu.Trigger className={cn(css.trigger, className)} {...props} asChild>
    {children}
  </DropdownMenu.Trigger>
);

interface ContentProps extends DropdownMenu.DropdownMenuContentProps {
  renderInPortal?: boolean;
}

const Content = (props: ContentProps) => {
  const { children, className, renderInPortal = true, ...otherProps } = props;

  /**
   * Because the Portal might try to pass a ref to it's child component, we can't have that be
   * some function component () => DropdownMenu.Content. Instead, we just modify the props and
   * duplicate the JSX.
   */
  const contentProps: ContentProps = {
    className: cn('z-py-8 z-br-4', css.content, className),
    align: 'center',
    side: 'bottom',
    sideOffset: 8,
    collisionPadding: 10,
    ...otherProps,
  };

  if (renderInPortal) {
    return (
      <DropdownMenu.Portal>
        <DropdownMenu.Content {...contentProps}>
          {children}
          <DropdownMenu.Arrow width={16} height={10} className={css.arrow} />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    );
  }

  return (
    <DropdownMenu.Content {...contentProps}>
      {children}
      <DropdownMenu.Arrow width={16} height={10} className={css.arrow} />
    </DropdownMenu.Content>
  );
};

const Item = ({ children, className, ...props }: DropdownMenu.DropdownMenuItemProps) => (
  <DropdownMenu.Item
    className={cn('z-py-8 z-px-20 shadow-none border-0 pointer', css.item, className)}
    {...props}
  >
    {children}
  </DropdownMenu.Item>
);

const Separator = ({
  className = 'z-mx-20 z-my-8',
  ...props
}: DropdownMenu.DropdownMenuSeparatorProps) => (
  <DropdownMenu.Separator className={cn(css.separator, className)} {...props} />
);

const MenuDropdown = ({ children, ...props }: DropdownMenu.DropdownMenuProps) => {
  return (
    <DropdownMenu.Root modal={false} {...props}>
      {children}
    </DropdownMenu.Root>
  );
};

MenuDropdown.Trigger = Trigger;
MenuDropdown.Content = Content;
MenuDropdown.Item = Item;
MenuDropdown.Separator = Separator;

export default MenuDropdown;
